import React from "react";
import { useVSU } from "../store";
import { pick, fmtDate } from "../helpers";
import EmptyState from "./EmptyState";

// Перечень видеопотоков (5.7, RQ.20.05). Навигация: клик по строке = выбор видеопотока.
// Состав и порядок строк — как в items[]; заголовок закреплён (sticky) при прокрутке.
const Dash = ({ v }) =>
  v ? <span>{v}</span> : <span className="vsu-dash">—</span>;

export default function StreamsList() {
  const { t, lang, items, selectedId, selectStream } = useVSU();

  return (
    <div className="vsu-list-box">
      <table className="vsu-table vsu-list-table">
        <thead>
          <tr>
            <th>{t("colSrc")}</th>
            <th>{t("colLoc")}</th>
            <th className="n">{t("colPlan")}</th>
            <th className="n">{t("colFact")}</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={4}>
                <EmptyState title={t("emptyT")} desc={t("emptyD")} />
              </td>
            </tr>
          ) : (
            items.map((s) => (
              <tr
                key={s.id}
                className={s.id === selectedId ? "sel" : ""}
                onClick={() => selectStream(s.id)}
              >
                <td>
                  {pick(s.source_name, lang)}
                  <br />
                  <span className="vsu-dash">{pick(s.address, lang)}</span>
                </td>
                <td>{pick(s.location, lang)}</td>
                <td className="n dt">
                  <Dash v={fmtDate(s.plan_date)} />
                </td>
                <td className="n dt">
                  <Dash v={fmtDate(s.fact_date)} />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
